/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The OrderEventsInner model module.
 * @module model/OrderEventsInner
 * @version v1
 */
export class OrderEventsInner {
  /**
   * Constructs a new <code>OrderEventsInner</code>.
   * @alias module:model/OrderEventsInner
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>OrderEventsInner</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/OrderEventsInner} obj Optional instance to populate.
   * @return {module:model/OrderEventsInner} The populated <code>OrderEventsInner</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new OrderEventsInner();
      if (data.hasOwnProperty('timestamp'))
        obj.timestamp = ApiClient.convertToType(data['timestamp'], 'String');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('message'))
        obj.message = ApiClient.convertToType(data['message'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} timestamp
 */
OrderEventsInner.prototype.timestamp = undefined;

/**
 * @member {String} name
 */
OrderEventsInner.prototype.name = undefined;

/**
 * @member {String} message
 */
OrderEventsInner.prototype.message = undefined;

